







































































































import {
    SET_COMPANY,
    CUSTOMER_CONTACT_DATA,
    IS_SPEAKER_EDIT,
} from '@/store/modules/offersModule';
import offerMixins from '@/helpers/offers/offerMixin';
import UserPicker from '@/components/common/userPicker.vue';
import { ACTION_GET_OFFICE_USERS_BY_EMAIL } from '@/store/modules/generic';

export default {
    mixins: [offerMixins],
    components: {
        UserPicker,
    },
    data() {
        return {
            closed: 'closed',
            format: 'dd/MM/yyyy',
            ownerData: '',
        };
    },
    async mounted(this: any) {
        if (!this.editOffer && !this.cloneOffer) {
            await this.selectDefaultUser(this);
        }
    },
    computed: {
        getBranches(this: any) {
            return this.$store.getters.branchData;
        },
        editOffer(this: any) {
            return this.$store.getters.isEdit_offer;
        },
        cloneOffer(this: any) {
            return this.$store.getters.isCloneOffer;
        },
    },

    methods: {
        branchValue(this: any, value: any) {
            this.$store.commit(SET_COMPANY, value);
        },
        async usersSelected(this: any, users: any) {
            this.offersData.owner.name = users.label;
            this.offersData.owner.email = users.value;
            this.offersData.owner.phone = users.phone;
        },
        async selectDefaultUser(this: any) {
            await this.$store.dispatch(ACTION_GET_OFFICE_USERS_BY_EMAIL);
            const userData = this.$store.getters.officeUsersByEmail;
            if (userData) {
                this.offersData.owner.name = userData.GivenName && userData.Surname
                    ? `${userData.GivenName} ${userData.Surname}`
                    : userData.DisplayName;
                this.offersData.owner.email = userData.UserPrincipalName;
                this.offersData.owner.phone = userData.MobilePhone;
            }
        },
    },
};
